import { apiClient } from '@app/lib'
import { type SugarDocumentsPaginatedResponse } from '@app/types'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useSession } from 'next-auth/react'

export const useDocuments = (page: number = 1) => {
  const session = useSession()

  return useQuery({
    enabled: session.status === 'authenticated',
    placeholderData: keepPreviousData,
    queryKey: ['documents', page],
    queryFn: async () => {
      const { data } = await apiClient.get<SugarDocumentsPaginatedResponse>('/api/documents', {
        params: {
          page: Math.max(1, page)
        }
      })

      return data
    }
  })
}
